<ng-container *transloco="let t">
    <div
        fxLayout="column"
        fxLayoutAlign="space-around start"
        class="container"
        fxFlex="940px"
        fxFlex.sm="90%"
        fxFlex.xs="90%"
    >
        <div fxLayout="row wrap" fxLayoutAlign="space-around start">
            <div
                fxFlex="940px"
                fxLayout.xs="column"
                fxLayoutAlign="space-between center"
                fxFlex.xs="90%"
                fxFlex.sm="100"
            >
                <h2>{{ t("support.help.title") }}</h2>
                <button
                    mat-raised-button
                    color="primary"
                    (click)="goBack()"
                    class="go-back"
                >
                    <mat-icon aria-hidden="false" aria-label="Go Back"
                        >arrow_back</mat-icon
                    >
                    {{ t("shared.go-back") | uppercase }}
                </button>
            </div>
            <div
                fxFlex="940px"
                fxLayoutAlign="start center"
                fxFlex.xs="90%"
                fxFlex.sm="100"
            >
                <p>{{ t("support.help.sub-title") }}</p>
            </div>
        </div>

        <mat-card appearance="outlined" style="width: 100%">
            <mat-tab-group animationDuration="0ms">
                <mat-tab>
                    <ng-template mat-tab-label>
                        {{ t("support.help.tabs.faq") }}
                    </ng-template>
                    <ng-container>
                        <div class="tab-content-container">
                            <h3>{{ t("support.help.tabs.tab1.title") }}</h3>
                            <mat-accordion multi="true">
                                <mat-expansion-panel
                                    (opened)="panelOpenState = true"
                                    (closed)="panelOpenState = false"
                                    *ngFor="let faq of faqs$ | async"
                                >
                                    <mat-expansion-panel-header
                                        class="help-expansion-header"
                                    >
                                        <mat-panel-title
                                            class="help-expansion-header-title"
                                        >
                                            {{ faq.question }}
                                        </mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <ng-template matExpansionPanelContent>
                                        <p
                                            class="description"
                                            [innerHTML]="faq.answer"
                                        ></p>
                                    </ng-template>
                                </mat-expansion-panel>
                            </mat-accordion>
                        </div>
                    </ng-container>
                </mat-tab>

                <mat-tab>
                    <ng-template mat-tab-label>
                        {{ t("support.help.tabs.contact-us") }}
                    </ng-template>
                    <ng-container>
                        <div class="tab-content-container">
                            <h3>{{ t("support.help.tabs.tab2.title") }}</h3>
                            <ng-container *ngIf="!this.submitted">
                                <p>
                                    {{ t("support.help.tabs.tab2.p1") }}
                                </p>
                                <form
                                    #form="ngForm"
                                    [formGroup]="requestForm"
                                    fxLayout="column"
                                    (ngSubmit)="onSubmit($event)"
                                >
                                    <div
                                        fxLayout="column"
                                        fxLayoutAlign="start left"
                                    >
                                        <div
                                            fxLayout="row"
                                            fxLayout.xs="column"
                                            fxLayoutAlign="start center"
                                        >
                                            <mat-form-field
                                                fxFlexFill
                                                appearance="outline"
                                                class="full-width"
                                            >
                                                <mat-label
                                                    >{{
                                                        t("shared.field.name")
                                                    }}
                                                </mat-label>
                                                <input
                                                    matInput
                                                    formControlName="name"
                                                    maxlength="200"
                                                />
                                                <mat-error
                                                    *ngIf="
                                                        name?.hasError(
                                                            'required'
                                                        )
                                                    "
                                                    >{{
                                                        t(
                                                            "shared.error.required.name"
                                                        )
                                                    }}
                                                </mat-error>
                                            </mat-form-field>
                                        </div>

                                        <div
                                            fxLayout="row wrap"
                                            fxLayout.xs="column"
                                            fxLayoutAlign="start center"
                                            fxLayoutGap="30px"
                                            fxLayoutGap.xs="0"
                                        >
                                            <div
                                                fxFlex="calc(50%-30px)"
                                                fxLayoutAlign="start center"
                                                fxFlex.xs="100"
                                                fxFlexFill
                                            >
                                                <mat-form-field
                                                    appearance="outline"
                                                    class="full-width"
                                                    fxFlexFill
                                                >
                                                    <mat-label
                                                        >{{
                                                            t(
                                                                "shared.field.email"
                                                            )
                                                        }}
                                                    </mat-label>
                                                    <input
                                                        matInput
                                                        type="email"
                                                        formControlName="email"
                                                        maxlength="200"
                                                    />
                                                    <mat-error
                                                        *ngIf="
                                                            email?.hasError(
                                                                'required'
                                                            )
                                                        "
                                                        >{{
                                                            t(
                                                                "shared.error.required.email"
                                                            )
                                                        }}
                                                    </mat-error>
                                                    <mat-error
                                                        *ngIf="
                                                            email?.hasError(
                                                                'email'
                                                            )
                                                        "
                                                        >{{
                                                            t(
                                                                "shared.error.email"
                                                            )
                                                        }}
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>
                                            <div
                                                fxFlex="calc(50%-30px)"
                                                fxLayoutAlign="start center"
                                                fxFlex.xs="100"
                                                fxFlexFill
                                            >
                                                <mat-form-field
                                                    appearance="outline"
                                                    fxFlexFill
                                                >
                                                    <mat-label>{{
                                                        t("shared.field.phone")
                                                    }}</mat-label>
                                                    <app-phone-input
                                                        formControlName="phone"
                                                    ></app-phone-input>
                                                    <mat-error
                                                        *ngIf="
                                                            phone?.hasError(
                                                                'pattern'
                                                            )
                                                        "
                                                        >{{
                                                            t(
                                                                "shared.error.pattern.phone"
                                                            )
                                                        }}
                                                    </mat-error>
                                                    <mat-hint>{{
                                                        t(
                                                            "shared.hint.optional"
                                                        )
                                                    }}</mat-hint>
                                                </mat-form-field>
                                            </div>
                                        </div>

                                        <div
                                            fxFlex="100"
                                            fxLayoutAlign="start center"
                                            fxFlex.xs="100"
                                            fxFlexFill
                                        >
                                            <mat-form-field
                                                appearance="outline"
                                                class="full-width"
                                                fxFlexFill
                                            >
                                                <mat-label>{{
                                                    t("shared.field.subject")
                                                }}</mat-label>
                                                <input
                                                    matInput
                                                    formControlName="subject"
                                                    maxlength="200"
                                                />
                                                <mat-error
                                                    *ngIf="
                                                        subject?.hasError(
                                                            'required'
                                                        )
                                                    "
                                                    >{{
                                                        t(
                                                            "shared.error.required.subject"
                                                        )
                                                    }}</mat-error
                                                >
                                            </mat-form-field>
                                        </div>

                                        <div
                                            fxFlexFill
                                            fxLayoutAlign="start center"
                                        >
                                            <mat-form-field
                                                class="full-width"
                                                appearance="outline"
                                                fxFlexFill
                                            >
                                                <mat-label>{{
                                                    t(
                                                        "shared.field.description"
                                                    )
                                                }}</mat-label>
                                                <textarea
                                                    matInput
                                                    formControlName="description"
                                                    placeholder="Enter details about your issue here..."
                                                    maxlength="5000"
                                                ></textarea>
                                                <mat-error
                                                    *ngIf="
                                                        description?.hasError(
                                                            'required'
                                                        )
                                                    "
                                                    >{{
                                                        t(
                                                            "shared.error.required.description"
                                                        )
                                                    }}
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                        <mat-form-field class="invisible">
                                            <input
                                                matInput
                                                formControlName="recaptcha"
                                                placeholder="recaptcha"
                                            />
                                        </mat-form-field>
                                        <re-captcha
                                            fxFlexFill
                                            siteKey="6LdRhUsUAAAAALQv-n0cTXKMZD-VHYhnFYFjWjKB"
                                            (resolved)="resolved($event!)"
                                        ></re-captcha>
                                        <mat-error
                                            *ngIf="
                                                recaptcha?.hasError('required')
                                            "
                                            style="
                                                font-weight: 500;
                                                line-height: 1.125;
                                                font-family: Gotham A, Gotham B;
                                                letter-spacing: 1.5px;
                                                font-size: 12px;
                                                padding-top: 8px;
                                                padding-left: 12px;
                                            "
                                            >{{
                                                t(
                                                    "shared.error.required.recaptcha"
                                                )
                                            }}
                                        </mat-error>

                                        <div
                                            fxFlex="50"
                                            fxLayoutAlign="start center"
                                            fxFlex.xs="100"
                                            fxFlexFill
                                        >
                                            <button
                                                mat-flat-button
                                                class="go-back"
                                                fxFlex="30"
                                                fxFlex.xs="100"
                                                style="height: 60px"
                                            >
                                                {{ t("shared.submit") }}
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </ng-container>
                            <ng-container *ngIf="this.submitted">
                                <p>
                                    {{
                                        t("support.help.tabs.tab2.p1-thankyou")
                                    }}
                                </p>
                            </ng-container>
                        </div>
                    </ng-container>
                </mat-tab>
            </mat-tab-group>
        </mat-card>
    </div>
</ng-container>
